import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "pre-med-plus-landing" */ './PreMedPlusLandingPage'));
